require('./brokerCustomWalletConfigurationHeader.scss');
//@vendors
const React = require("react");
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
// @utilities
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;
//commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

//constants
const { BROKER_CUSTOM_WALLET_INVESTMENTS } = require('../../constants/index');
const { BROKER_CUSTOM_WALLET_MY_WALLET_CREATE_NEW_VIEW } = require('constants/index');

class BrokerCustomWalletConfigurationHeader extends React.Component {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    buildOkButton() {
        const lessThanTheMaximumViews = this.props.immBrokerCustomWalletPortfolios.get('lessThanTheMaximumViews');
        const canCreateNew = this.props.immBrokerCustomWalletPortfolios.get('canCreateNew');
        const okButton = (
            <OKButton
                modifier="primary"
                size="regular"
                disabled={!canCreateNew}
                onClick={this.handleClick}
            >
                {formatText("brokerCustomWallet-configureNewViewButton")}
            </OKButton>
        );
        const tooltipTarget = (
            <span
                className="buttons-base buttons-base--primary buttons-base--regular"
                disabled={true}
            >
                <FormattedText
                    className="buttons-base__children--tooltip"
                    value="brokerCustomWallet-configureNewViewButton"
                />
            </span>
        );
        const showTooltipMaxViews = (
            <OKTooltip
                content="brokerCustomWallet-configureNewViewButtonMaxTooltip"
                offset={[0, -10]}
                target={tooltipTarget}
            />
        );
        const disableWithTooltip = !lessThanTheMaximumViews;

        return disableWithTooltip ?
            showTooltipMaxViews :
            okButton;
    }

    handleClick() {
        this.props.history.push(BROKER_CUSTOM_WALLET_MY_WALLET_CREATE_NEW_VIEW);
    }

    render() {
        const okButton = this.buildOkButton();

        //breadcrums definitions
        const mappingBreadcrumb = [
            {
                text: formatText("brokerCustomWallet-breadcrumbInvestments"),
                url: BROKER_CUSTOM_WALLET_INVESTMENTS
            },
            {
                text: formatText("brokerCustomWallet-breadcrumbConfiguration")
            }
        ];


        return (
            <div className="custom-wallet-configuration-header container-fluid">
                <OKHeaderSubPage
                    breadcrumbConfig={mappingBreadcrumb}
                    isSubtitleLeftCapital={false}
                    finalTitle={getFinalTitle('brokerCustomWallet-configurationViewTitle')}
                >

                    {okButton}

                </OKHeaderSubPage>
            </div>
        );
    }
}

BrokerCustomWalletConfigurationHeader.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerCustomWalletPortfolios: PropTypes.any.isRequired,
};

module.exports = withRouter(BrokerCustomWalletConfigurationHeader);
